import { render, staticRenderFns } from "./ExpiredLinkPage.vue?vue&type=template&id=0b32fdd8&scoped=true&"
import script from "./ExpiredLinkPage.vue?vue&type=script&lang=js&"
export * from "./ExpiredLinkPage.vue?vue&type=script&lang=js&"
import style0 from "./ExpiredLinkPage.vue?vue&type=style&index=0&id=0b32fdd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b32fdd8",
  null
  
)

export default component.exports